import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useState } from "react"
import useListGroupBu from "../../buManagement/groupBu/ListGroupBusinessUnit/useListGroupBu"
import { useNavigate } from "react-router-dom"

const useProjectForm = () => {
    const navigate = useNavigate()
    const [isSaving, setIsSaving] = useState(false)
    const [payload, setPayload] = useState({
        ID: '',
        Name: '',
        Year: '',
        Status: false
    })
    const [groupBu, setGroupBu] = useState([])
    const { getListGroupBu } = useListGroupBu()

    const getGroupBu = async () => {
        const groupBuData = await getListGroupBu();
        setGroupBu(groupBuData)
    }

    const onChangeHandler = (e) => {
        if (e.target.name.includes("Limit")) {
            const gbuName = e.target.name.split('.')[0]
            const field = e.target.name.split('.')[1]
            setPayload((prevPayload) => ({
                ...prevPayload,
                [gbuName]: {
                    ...prevPayload[gbuName],
                    [field]: e.target.value,
                },
            }));
        } else {
            setPayload((prevPayload) => ({ ...prevPayload, [e.target.name]: e.target.value }));
        }
        if (e.target.type === "checkbox") {
            setPayload((prevPayload) => ({ ...prevPayload, [e.target.name]: e.target.checked }));
        }
    };

    const postProjectForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/projects', {
                Name: payload.Name,
                Status: false,
                Year: parseInt(payload.Year),
                APlusExcess: payload.APlusExcess,
                AExcess: payload.AExcess,
                BPlusExcess: payload.BPlusExcess,
                BExcess: payload.BExcess,
                CExcess: payload.CExcess,
                DExcess: payload.DExcess
            })
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Add Projects")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const putProjectForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/projects', {
                ID: payload.ID,
                Name: payload.Name,
                Status: false,
                Year: parseInt(payload.Year),
                APlusExcess: payload.APlusExcess,
                AExcess: payload.AExcess,
                BPlusExcess: payload.BPlusExcess,
                BExcess: payload.BExcess,
                CExcess: payload.CExcess,
                DExcess: payload.DExcess
            })
            if (res.status === 200) {
                toast.success("Success Update Projects")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }


        try {
            for (const gbu of groupBu) {
                if (gbu.Status === true) {
                    // console.log(payload[gbu.GroupName])
                    let payloadGbu = {
                        ...preProcess(payload[gbu.GroupName]),
                        ProjectId: payload.ID,
                        GroupBusinessUnitID: gbu.ID
                    }
                    // console.log(payloadGbu)
                    let res = await axiosInstance.post('/auth/score-distribution', payloadGbu)
                    if (res.status === 200) {
                        toast.success(`Success Update Score Distribution ${gbu.GroupName}`)
                        navigate(`/project-list/project/${payload.ID}/1`)
                    }
                }
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const preProcess = (data) => {
        let res = {}
        res.APlusLowerLimit = parseFloat(data.APlusLowerLimit)
        res.APlusUpperLimit = parseFloat(data.APlusUpperLimit)
        res.ALowerLimit = parseFloat(data.ALowerLimit)
        res.AUpperLimit = parseFloat(data.AUpperLimit)
        res.BPlusLowerLimit = parseFloat(data.BPlusLowerLimit)
        res.BPlusUpperLimit = parseFloat(data.BPlusUpperLimit)
        res.BLowerLimit = parseFloat(data.BLowerLimit)
        res.BUpperLimit = parseFloat(data.BUpperLimit)
        res.CLowerLimit = parseFloat(data.CLowerLimit)
        res.CUpperLimit = parseFloat(data.CUpperLimit)
        res.DLowerLimit = parseFloat(data.DLowerLimit)
        res.DUpperLimit = parseFloat(data.DUpperLimit)
        res.GroupBusinessUnitID = data.GroupBusinessUnitID
        return res
    }

    const getProjectForm = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/${id}`)
            if (res.status === 200) {
                let data = {}
                if ((res.data.data.ScoreDistributions.length) > 0) {
                    for (const group of res.data.data.ScoreDistributions) {
                        // console.log("preprocess",group)
                        data[group.GroupBusinessUnit.GroupName] = {
                            GroupBusinessUnitID: group.GroupBusinessUnitID,
                            APlusLowerLimit: group.APlusLowerLimit,
                            APlusUpperLimit: group.APlusUpperLimit,
                            ALowerLimit: group.ALowerLimit,
                            AUpperLimit: group.AUpperLimit,
                            BPlusLowerLimit: group.BPlusLowerLimit,
                            BPlusUpperLimit: group.BPlusUpperLimit,
                            BLowerLimit: group.BLowerLimit,
                            BUpperLimit: group.BUpperLimit,
                            CLowerLimit: group.CLowerLimit,
                            CUpperLimit: group.CUpperLimit,
                            DLowerLimit: group.DLowerLimit,
                            DUpperLimit: group.DUpperLimit,
                        }
                    }
                    // console.log("data 2:",data)
                }
                setPayload((prevPayload) => ({ ...prevPayload, ...res.data.data, ...data }))
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        onChangeHandler,
        postProjectForm,
        putProjectForm,
        getProjectForm,
        groupBu,
        getGroupBu,
        isSaving,
        // scoringMethod,
        // handleSelectScoringMethod
    }
}

export default useProjectForm